import axios from 'axios';

const taskVotingApi = {
  setSelectedTenant(tenant) {
    axios.defaults.headers.common['X-tenant-id'] = tenant;
  },


  async getVotes() {
    const response = await axios.get('/api/tenant/taskvoting');
    return response.data;
  },
  async getVote(id) {
    const response = await axios.get(`/api/tenant/taskvoting/${id}`);
    return response.data;
  },
  async getVotesByTask(task) {
    const response = await axios.get('/api/tenant/taskvoting/bytask/' + task.id);
    return response.data;
  },
  async getVotesBySession(sessionId) {
    const response = await axios.put(`/api/tenant/taskvoting/bysession/${sessionId}`, sessionId);
    return response.data;
  },
  async createOrUpdateVote(vote) {
    const response = await axios.post('/api/tenant/taskvoting', vote);
    return response.data;
  },
  async deleteVote(id) {
    const response = await axios.delete(`/api/tenant/taskvoting/${id}`);
    return response.data;
  },


  /* SHARED / PUBLIC */
  async getVotesBySessionShared(sessionId) {
    const response = await axios.get(`/api/shared/taskvoting/bysession/${sessionId}`);
    return response.data;
  },
  async createOrUpdateVoteShared(vote) {
    const response = await axios.post('/api/tenant/taskvoting', vote);
    return response.data;
  },
  async getTasksShared() {
    const response = await axios.get('/api/shared/taskvoting/tasks');
    return response.data;
  }
};

export default taskVotingApi;
